import { useEffect, useState }   from 'react'
import { ratingAdvocateService } from "../services";
import { useLocation }           from "react-router";
import { setAlertNotification }  from "../actions/util";

export const useRatingAdvocateList = (props) => {

  const {id, onChange} = props || {};

  const location = useLocation();
  let param = new URLSearchParams(location.search);
  const ratingParamId = param.get("rating");

  const [ratingAdvocates, setRatingAdvocates] = useState([]);

  const getRatingAdvocates = (ratingId) => {
    if (ratingId || id || ratingParamId) {
      ratingAdvocateService()
        .getAllByRating(ratingId || id || ratingParamId)
        .then(res => {
          if (res && res.data) {
            setRatingAdvocates(res.data);
            if (onChange) {
              onChange(res.data);
            }
          }
        })
        .catch(err => {
          setRatingAdvocates({});
          if (onChange) {
            onChange({});
          }
        })
    }
  };

  useEffect(() => {
    getRatingAdvocates()
    // eslint-disable-next-line
  }, [ratingParamId, id]);

  const deleteRatingAdvocate = (id) => {
    ratingAdvocateService()
      .deleteAdvocate({id})
      .then(res => {
        getRatingAdvocates()
      })
      .catch(err => {
        setAlertNotification("Error deleting an Advocate", "danger")
      });
  }

  return {
    ratingAdvocates,
    getRatingAdvocates,
    ratingId: ratingParamId,
    deleteRatingAdvocate
  }
};
